module.exports = __webpack_public_path__ + "static/media/pickup_yellow.11fa9ac8.svg";